import "./Navbar.scss";
import { useNavigate } from "react-router";
import { Dropdown } from "semantic-ui-react";
import Config from "../../config/Config";
import { NewWrampsLogo } from "./NewWrampsLogo";
import { Translation } from "react-i18next";
import { AuthLoginComponent } from "../authComponents/authLoginComponent/authLoginComponent";
import { useAuth } from "react-oidc-context";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import { SidebarContext } from "../../core/SidebarComponent";

export const Navbar = (props: any) => {
    let navigate = useNavigate();
    const { dispatchSidebar } = useContext(SidebarContext);

    const auth = useAuth();

    // Function to handle navigation with sidebar close
    const handleNavigation = (path: string, tabState?: string) => {
        // Close sidebar
        if (dispatchSidebar) {
            dispatchSidebar({ type: "close" });
        }

        navigate(path);

        if (tabState && props.setTabState) {
            props.setTabState(tabState);
        }
    };

    return (
        <div className="navbar">
            <Translation>
                {t =>
                    <div className={`overlay`} style={{ background: Config.env === "qa" ? "rgb(255, 204, 0)" : "#ffffff", }}>
                        <div className="nav-inner-container">
                            <div className="left-container ">
                                <div
                                    className="bars-div"
                                    title={t("welcomeTitle")}
                                    onClick={() => handleNavigation("/welcome", "welcomePage")}
                                >
                                    <NewWrampsLogo />
                                </div>
                                <div className="nav-show left-container-links">
                                    <NavLink to="/progress-reporting" className="nav-menu-show expand">Progress Reporting</NavLink>
                                    <NavLink to="/capture" className="nav-menu-show expand">CAPTURE</NavLink>
                                    <NavLink to="/cobenefits" className="nav-menu-show expand">Co-Benefits </NavLink>
                                </div>
                            </div>

                            {/* starts English/Spanish links in Navbar */}
                            {props.screenDisplayType === "desktop" && (
                                <>
                                    <div className="nav-show">
                                        <div className="nav-items-div">
                                            {
                                                auth.user && <>
                                                    <NavLink to="/reports" className="nav-menu-show expand">{t("navbarReporting")}</NavLink>
                                                    <NavLink to="/help" className="nav-menu-show expand">{t("navbarHelp")}</NavLink>
                                                </>
                                            }

                                            {!auth.user &&
                                                <AuthLoginComponent
                                                    loginLabel={t("navbarLogin")}
                                                    logoutLabel={t("navbarLogout")}
                                                />
                                            }

                                            {/* Start of hamburger menu that always shows */}
                                            {auth.user &&
                                                <div className="nav-dropdown">
                                                    <Dropdown
                                                        icon="bars"
                                                        className="menu-dropdown"
                                                        fluid
                                                        pointing="top right"
                                                    >
                                                        <Dropdown.Menu id="styledMenu">
                                                            {auth.user && (auth.user?.profile.role as string).indexOf("admin") > -1 &&
                                                                <Dropdown.Item
                                                                    onClick={() =>
                                                                        window.location.href = Config.authInfo.server + "/UserPermissions?returnUrl=" + Config.appUrl}
                                                                    text={t("navbarAdmin")}
                                                                />
                                                            }

                                                            <Dropdown.Item
                                                                onClick={() =>
                                                                    window.location.href = Config.authInfo.server + "/Manage/ChangePassword"}
                                                                text={t("navbarChngPw")}
                                                            />
                                                            {/* name this div "item" so it would match the styling as <Dropdown.Item> */}
                                                            <div className="item">
                                                                <AuthLoginComponent
                                                                    loginLabel={t("navbarLogin")}
                                                                    logoutLabel={t("navbarLogout")}
                                                                />

                                                            </div>

                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            } {/* End of hamburger menu that always shows*/}
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Start of mobile view dropdown */}
                            {
                                props.screenDisplayType === "mobile" &&
                                <>
                                    <div className="nav-dropdown">
                                        <Dropdown
                                            icon="bars"
                                            className="menu-dropdown nav-menu-item"
                                            fluid
                                            pointing="top right"
                                        >
                                            <Dropdown.Menu id="mobileMenu">
                                                <Dropdown.Item
                                                    onClick={() => handleNavigation("/welcome")}
                                                    text={t("navbarWelcome")}
                                                />
                                                <Dropdown.Item
                                                    onClick={() => handleNavigation("/capture", "capture")}
                                                    text={"Capture"}
                                                />
                                                <Dropdown.Item
                                                    onClick={() => handleNavigation("/welcome", "wsGroup")}
                                                    text={"Progress Reporting"}
                                                />
                                                <Dropdown.Item
                                                    onClick={() => handleNavigation("/welcome", "cobenefits")}
                                                    text={"Co-Benefits"}
                                                />

                                                {auth.user &&
                                                    <>
                                                        <Dropdown.Item
                                                            onClick={() => handleNavigation("/reports")}
                                                            text={t("navbarReporting")}
                                                        />
                                                        <Dropdown.Item
                                                            onClick={() => window.location.href = Config.authInfo.server + "/Manage/ChangePassword"}
                                                            text={t("navbarChngPw")}
                                                        />
                                                    </>
                                                }

                                                {auth.user && (auth.user.profile.role as string[]).indexOf("admin") > -1 &&
                                                    <Dropdown.Item
                                                        onClick={() => window.location.href = Config.authInfo.server + "/UserPermissions?returnUrl=" + Config.appUrl}
                                                        text={t("navbarAdmin")}
                                                    />
                                                }

                                                <Dropdown.Item>
                                                    <AuthLoginComponent
                                                        loginLabel={t("navbarLogin")}
                                                        logoutLabel={t("navbarLogout")}
                                                    />
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </>
                            }
                            {/* End of mobile view dropdown */}
                        </div>
                    </div>
                }
            </Translation>
        </div>
    );
};
